export default "__VITE_ASSET__DHypCAoO__"